// extracted by mini-css-extract-plugin
export default {"imageWrapper":"pR-z","hovered":"qR-z","hoverImage":"rR-z","mainImage":"sR-z","imageNoBackground":"tR-z","fullSizeImage":"uR-z"};